var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper preview__wrapper d-flex",style:(_vm.wrapperStyles)},[(_vm.item.properties.imageUrl)?_c('img',{staticStyle:{"height":"fit-content","margin":"5px 10px"},attrs:{"src":_vm.item.properties.imageUrl}}):_vm._e(),_c('div',{style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.item.properties.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }